/* import __COLOCATED_TEMPLATE__ from './icon-undetermined.hbs'; */
import SvgIcon from '@square/glass-ui/components/svg/svg-icon';
export default SvgIcon.extend({
  classNames: ['svg-icon--undetermined'],
  viewBox: '-3 -3 14 8',
  width: 16,
  height: 16
});